import { mapActions, mapGetters } from 'vuex';
import SchoolLogo from './SchoolLogo';
import MakeupDayLink from './MakeupDayLink';
import SelectColor from '../widgets/SelectColor';
export default {
  name: 'Profile',
  props: {
    projectId: {
      type: Number,
      required: true
    }
  },
  created() {
    this.fetchProfile({
      projectID: this.projectId
    });
  },
  methods: {
    ...mapActions('profile', ['fetchProfile']),
    onSelectColor() {
      this.$refs.selectColor.show();
    }
  },
  computed: {
    ...mapGetters('profile', ['manager', 'profile', 'project', 'loading'])
  },
  components: {
    SchoolLogo,
    MakeupDayLink,
    SelectColor
  }
};